import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './EditorCanvas.module.sass'
import { useFabricEditor } from '@hooks/useFabricEditor'
import { ArticoloType, EditorColorType } from '@utils/types'

interface Props {
  className?: string
  personalizzazione?: any
  colore?: EditorColorType
  articoli?: ArticoloType[]
  isVisible: boolean
  preview?: boolean
}

const EditorCanvas = (props: Props) => {
  const {
    className = '',
    personalizzazione,
    colore,
    articoli = [],
    isVisible = false,
    preview = false,
  } = props

  const { canvasContainerRef, canvasElRef } = useFabricEditor(
    personalizzazione,
    colore,
    isVisible,
    preview,
    articoli
  )

  return (
    <div className={cn(styles.root, className, !isVisible ? styles['root--hidden'] : '')}>
      <div ref={canvasContainerRef} className={styles.canvas}>
        <canvas id={`main-canvas-${personalizzazione?.id}-${colore?.id}`} ref={canvasElRef} />
      </div>
    </div>
  )
}

export default EditorCanvas
